import { useEffect, useState } from 'react'
import { Dayjs } from 'dayjs'
import SignUpForm1 from './SignUpForm1'
import SignUpForm2 from './SignUpForm2'
import SignUpForm3 from './SignUpForm3'
import { AuthUser } from '@/types'
import {
  useSignup,
  useConfirmSignup,
  useRegisterCognito,
  useResendSignupCode,
} from '@/hooks/api/auth'

export default function SignUp() {
  const [userData, setUserData] = useState<AuthUser>({
    user: '',
    password: '',
    firstName: '',
    lastName: '',
    dob: null,
    code: '',
  })
  const [step, setStep] = useState(1)

  const signup = useSignup(userData.user, userData.password)
  const confirm = useConfirmSignup(userData.user, userData.code)
  const registerCognito = useRegisterCognito(userData)
  const resendCode = useResendSignupCode(userData.user)

  useEffect(() => {
    if (signup.isSuccess) {
      setStep(2)
    }
  }, [signup.isSuccess])

  useEffect(() => {
    if (confirm.isSuccess) {
      registerCognito.mutate()
    }
  }, [confirm.isSuccess])

  const onSubmitForm1 = async (user: string, password: string) => {
    setUserData({ ...userData, user, password })
    signup.mutate()
  }

  const onSubmitForm2 = (firstName: string, lastName: string, dob: Dayjs) => {
    setUserData({ ...userData, firstName, lastName, dob })
    setStep(3)
  }

  const onSubmitForm3 = (code: string) => {
    setUserData({ ...userData, code })
    setTimeout(() => {
      confirm.mutate()
    })
  }

  const onResendVerificationCode = () => {
    resendCode.mutate()
  }

  if (step === 2) return <SignUpForm2 onSubmit={onSubmitForm2} />
  if (step === 3) {
    return (
      <SignUpForm3
        user={userData.user}
        onSubmit={onSubmitForm3}
        onResend={onResendVerificationCode}
        loading={confirm.isLoading || resendCode.isLoading}
        error={confirm.error?.toString() || ''}
      />
    )
  }
  return (
    <SignUpForm1
      onSubmit={onSubmitForm1}
      loading={signup.isLoading}
      error={signup.error?.toString() || ''}
    />
  )
}
